import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { vehicleValidationForm } from "../../utils/validationSchemas";
import VehicleForm from "./VehicleForm";

const CreateVehicle = (props: any) => {
  const {
    handleCreate,
    isLoading,
    defaultVehicleCategory,
    defaultVehicleType,
  } = props;

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    getValues,
    clearErrors,
    setValue,
  } = useForm<any>({
    resolver: yupResolver(vehicleValidationForm),
    defaultValues: async () => {
      return {
        vehicle_type: defaultVehicleType?.[0],
        vehicle_category: defaultVehicleCategory?.[0],
      };
    },
  });

  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <VehicleForm
        errors={errors}
        getValues={getValues}
        register={register}
        setValue={setValue}
        clearErrors={clearErrors}
      />
    </FormLayout>
  );
};

export default CreateVehicle;
